import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { defineNuxtPlugin, useRuntimeConfig } from "#app";
import { setupConsoleLogging, setupPageTracking, setupVueErrorHandling } from "./vue.js";
function getApplicationInsightsClientProxy(client) {
  const proxy = {
    trackTrace: (message) => {
      client?.trackTrace({
        message
      });
    }
  };
  return proxy;
}
export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();
  const config = {
    ...runtimeConfig.public.nloApplicationInsights || {}
  };
  const client = new ApplicationInsights({
    config: {
      connectionString: config.serverConnectionString,
      samplingPercentage: config.samplingPercentage ?? 100
    }
  }).loadAppInsights();
  setupVueErrorHandling(client);
  setupPageTracking(client);
  setupConsoleLogging(client);
  return {
    provide: {
      appInsights: getApplicationInsightsClientProxy(client)
    }
  };
});
